<lib-page-container title="Advertiser details" [loading]="loading" [version]="appVersion.version"
  [apiVersion]="appVersion.apiVersion$ | async">
  <div lib-page-breadcrumbs>
    <lib-breadcrumbs></lib-breadcrumbs>
  </div>
  <div lib-page-actions>
    <lib-button *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]"
      tooltip="Edit Advertiser" icon="edit" (buttonClick)="onSettings(advertiser)">Edit</lib-button>
    <lib-button *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_CREATE]"
      tooltip="Migration Campaigns" icon="sync" (buttonClick)="onMigrationCampaigns()">Migration Campaigns</lib-button>
    <lib-button tooltip="Refresh" icon="replay" (buttonClick)="onRefresh()">Refresh</lib-button>
  </div>
  <div lib-page-body>
    <div class="flex-row gap-16">
      <div class="flex-column gap-16">
        <mat-card appearance="outlined">
          <mat-card-content>
            @if (advertiser) {
            <app-advertiser-details [advertiser]="advertiser" [isFullScreen]="true"></app-advertiser-details>
            }
          </mat-card-content>
        </mat-card>
      </div>
      @if (advertiser) {
      <app-advertiser-campaigns class="flex-1" [advertiserId]="advertiser.id"></app-advertiser-campaigns>
      }
    </div>
  </div>
</lib-page-container>